import Clock from '@public/svg/clock.svg?component';
import FlagUSA from '@public/svg/flag-usa.svg?component';
import Phone from '@public/svg/phone.svg?component';
import clsx from 'clsx';
import type { FC, SVGProps } from 'react';

interface IconPoint {
  icon: string | FC<SVGProps<SVGSVGElement>>;
  text: string;
}

const iconPoints: IconPoint[] = [
  {
    icon: 'CLIA',
    text: 'CLIA-Certified Lab',
  },
  {
    icon: Phone,
    text: 'Free DNA Insights Session with an Expert',
  },
  {
    icon: Clock,
    text: 'Results within 1 week',
  },
  {
    icon: FlagUSA,
    text: 'Located in Salt Lake City, Utah, USA',
  },
];

interface ShopSwabKitIconPointsProps {
  className?: string;
}

export const ShopSwabKitIconPoints: React.FC<ShopSwabKitIconPointsProps> = ({ className }) => {
  return (
    <div className={clsx('bg-alter25-cream-b', className)}>
      <div className={clsx('container py-8')}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-0 gap-y-4">
          {iconPoints.map((iconPoint, index) => (
            <div className="flex justify-start flex-nowrap items-center" key={index}>
              {typeof iconPoint.icon === 'string' ? (
                <div
                  className={clsx(
                    'shrink-0 me-4',
                    'border border-1 border-badge-gray rounded-[78px]',
                    'text-sm leading-[19.6px] tracking-[-0.42px] ',
                    'px-1 py-[10px]',
                    'md:px-2 md:py-[14px]'
                  )}
                >
                  {iconPoint.icon}
                </div>
              ) : (
                <div
                  className={clsx(
                    'shrink-0 me-4',
                    'border border-1 border-badge-gray rounded-[78px]',
                    'p-[10px] md:p-[14px]'
                  )}
                >
                  <iconPoint.icon />
                </div>
              )}
              <div
                className={clsx(
                  'font-light',
                  'text-base] leading-[24px] tracking-[-0.48px]',
                  'md:text-lg md:leading-[25.2px] md:tracking-[-0.54px]'
                )}
              >
                {iconPoint.text}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
